// 6502 opcode definitions for disassembly
export const OPCODES: Record<number, { name: string; mode: string; bytes: number }> = {
    0x00: { name: 'BRK', mode: 'imp', bytes: 1 },
    0x01: { name: 'ORA', mode: 'izx', bytes: 2 },
    0x05: { name: 'ORA', mode: 'zp', bytes: 2 },
    0x06: { name: 'ASL', mode: 'zp', bytes: 2 },
    0x08: { name: 'PHP', mode: 'imp', bytes: 1 },
    0x09: { name: 'ORA', mode: 'imm', bytes: 2 },
    0x0A: { name: 'ASL', mode: 'acc', bytes: 1 },
    0x0D: { name: 'ORA', mode: 'abs', bytes: 3 },
    0x0E: { name: 'ASL', mode: 'abs', bytes: 3 },
    0x10: { name: 'BPL', mode: 'rel', bytes: 2 },
    0x11: { name: 'ORA', mode: 'izy', bytes: 2 },
    0x15: { name: 'ORA', mode: 'zpx', bytes: 2 },
    0x16: { name: 'ASL', mode: 'zpx', bytes: 2 },
    0x18: { name: 'CLC', mode: 'imp', bytes: 1 },
    0x19: { name: 'ORA', mode: 'aby', bytes: 3 },
    0x1D: { name: 'ORA', mode: 'abx', bytes: 3 },
    0x1E: { name: 'ASL', mode: 'abx', bytes: 3 },
    0x20: { name: 'JSR', mode: 'abs', bytes: 3 },
    0x21: { name: 'AND', mode: 'izx', bytes: 2 },
    0x24: { name: 'BIT', mode: 'zp', bytes: 2 },
    0x25: { name: 'AND', mode: 'zp', bytes: 2 },
    0x26: { name: 'ROL', mode: 'zp', bytes: 2 },
    0x28: { name: 'PLP', mode: 'imp', bytes: 1 },
    0x29: { name: 'AND', mode: 'imm', bytes: 2 },
    0x2A: { name: 'ROL', mode: 'acc', bytes: 1 },
    0x2C: { name: 'BIT', mode: 'abs', bytes: 3 },
    0x2D: { name: 'AND', mode: 'abs', bytes: 3 },
    0x2E: { name: 'ROL', mode: 'abs', bytes: 3 },
    0x30: { name: 'BMI', mode: 'rel', bytes: 2 },
    0x31: { name: 'AND', mode: 'izy', bytes: 2 },
    0x35: { name: 'AND', mode: 'zpx', bytes: 2 },
    0x36: { name: 'ROL', mode: 'zpx', bytes: 2 },
    0x38: { name: 'SEC', mode: 'imp', bytes: 1 },
    0x39: { name: 'AND', mode: 'aby', bytes: 3 },
    0x3D: { name: 'AND', mode: 'abx', bytes: 3 },
    0x3E: { name: 'ROL', mode: 'abx', bytes: 3 },
    0x40: { name: 'RTI', mode: 'imp', bytes: 1 },
    0x41: { name: 'EOR', mode: 'izx', bytes: 2 },
    0x45: { name: 'EOR', mode: 'zp', bytes: 2 },
    0x46: { name: 'LSR', mode: 'zp', bytes: 2 },
    0x48: { name: 'PHA', mode: 'imp', bytes: 1 },
    0x49: { name: 'EOR', mode: 'imm', bytes: 2 },
    0x4A: { name: 'LSR', mode: 'acc', bytes: 1 },
    0x4C: { name: 'JMP', mode: 'abs', bytes: 3 },
    0x4D: { name: 'EOR', mode: 'abs', bytes: 3 },
    0x4E: { name: 'LSR', mode: 'abs', bytes: 3 },
    0x50: { name: 'BVC', mode: 'rel', bytes: 2 },
    0x51: { name: 'EOR', mode: 'izy', bytes: 2 },
    0x55: { name: 'EOR', mode: 'zpx', bytes: 2 },
    0x56: { name: 'LSR', mode: 'zpx', bytes: 2 },
    0x58: { name: 'CLI', mode: 'imp', bytes: 1 },
    0x59: { name: 'EOR', mode: 'aby', bytes: 3 },
    0x5D: { name: 'EOR', mode: 'abx', bytes: 3 },
    0x5E: { name: 'LSR', mode: 'abx', bytes: 3 },
    0x60: { name: 'RTS', mode: 'imp', bytes: 1 },
    0x61: { name: 'ADC', mode: 'izx', bytes: 2 },
    0x65: { name: 'ADC', mode: 'zp', bytes: 2 },
    0x66: { name: 'ROR', mode: 'zp', bytes: 2 },
    0x68: { name: 'PLA', mode: 'imp', bytes: 1 },
    0x69: { name: 'ADC', mode: 'imm', bytes: 2 },
    0x6A: { name: 'ROR', mode: 'acc', bytes: 1 },
    0x6C: { name: 'JMP', mode: 'ind', bytes: 3 },
    0x6D: { name: 'ADC', mode: 'abs', bytes: 3 },
    0x6E: { name: 'ROR', mode: 'abs', bytes: 3 },
    0x70: { name: 'BVS', mode: 'rel', bytes: 2 },
    0x71: { name: 'ADC', mode: 'izy', bytes: 2 },
    0x75: { name: 'ADC', mode: 'zpx', bytes: 2 },
    0x76: { name: 'ROR', mode: 'zpx', bytes: 2 },
    0x78: { name: 'SEI', mode: 'imp', bytes: 1 },
    0x79: { name: 'ADC', mode: 'aby', bytes: 3 },
    0x7D: { name: 'ADC', mode: 'abx', bytes: 3 },
    0x7E: { name: 'ROR', mode: 'abx', bytes: 3 },
    0x81: { name: 'STA', mode: 'izx', bytes: 2 },
    0x84: { name: 'STY', mode: 'zp', bytes: 2 },
    0x85: { name: 'STA', mode: 'zp', bytes: 2 },
    0x86: { name: 'STX', mode: 'zp', bytes: 2 },
    0x88: { name: 'DEY', mode: 'imp', bytes: 1 },
    0x8A: { name: 'TXA', mode: 'imp', bytes: 1 },
    0x8C: { name: 'STY', mode: 'abs', bytes: 3 },
    0x8D: { name: 'STA', mode: 'abs', bytes: 3 },
    0x8E: { name: 'STX', mode: 'abs', bytes: 3 },
    0x90: { name: 'BCC', mode: 'rel', bytes: 2 },
    0x91: { name: 'STA', mode: 'izy', bytes: 2 },
    0x94: { name: 'STY', mode: 'zpx', bytes: 2 },
    0x95: { name: 'STA', mode: 'zpx', bytes: 2 },
    0x96: { name: 'STX', mode: 'zpy', bytes: 2 },
    0x98: { name: 'TYA', mode: 'imp', bytes: 1 },
    0x99: { name: 'STA', mode: 'aby', bytes: 3 },
    0x9A: { name: 'TXS', mode: 'imp', bytes: 1 },
    0x9D: { name: 'STA', mode: 'abx', bytes: 3 },
    0xA0: { name: 'LDY', mode: 'imm', bytes: 2 },
    0xA1: { name: 'LDA', mode: 'izx', bytes: 2 },
    0xA2: { name: 'LDX', mode: 'imm', bytes: 2 },
    0xA4: { name: 'LDY', mode: 'zp', bytes: 2 },
    0xA5: { name: 'LDA', mode: 'zp', bytes: 2 },
    0xA6: { name: 'LDX', mode: 'zp', bytes: 2 },
    0xA8: { name: 'TAY', mode: 'imp', bytes: 1 },
    0xA9: { name: 'LDA', mode: 'imm', bytes: 2 },
    0xAA: { name: 'TAX', mode: 'imp', bytes: 1 },
    0xAC: { name: 'LDY', mode: 'abs', bytes: 3 },
    0xAD: { name: 'LDA', mode: 'abs', bytes: 3 },
    0xAE: { name: 'LDX', mode: 'abs', bytes: 3 },
    0xB0: { name: 'BCS', mode: 'rel', bytes: 2 },
    0xB1: { name: 'LDA', mode: 'izy', bytes: 2 },
    0xB4: { name: 'LDY', mode: 'zpx', bytes: 2 },
    0xB5: { name: 'LDA', mode: 'zpx', bytes: 2 },
    0xB6: { name: 'LDX', mode: 'zpy', bytes: 2 },
    0xB8: { name: 'CLV', mode: 'imp', bytes: 1 },
    0xB9: { name: 'LDA', mode: 'aby', bytes: 3 },
    0xBA: { name: 'TSX', mode: 'imp', bytes: 1 },
    0xBC: { name: 'LDY', mode: 'abx', bytes: 3 },
    0xBD: { name: 'LDA', mode: 'abx', bytes: 3 },
    0xBE: { name: 'LDX', mode: 'aby', bytes: 3 },
    0xC0: { name: 'CPY', mode: 'imm', bytes: 2 },
    0xC1: { name: 'CMP', mode: 'izx', bytes: 2 },
    0xC4: { name: 'CPY', mode: 'zp', bytes: 2 },
    0xC5: { name: 'CMP', mode: 'zp', bytes: 2 },
    0xC6: { name: 'DEC', mode: 'zp', bytes: 2 },
    0xC8: { name: 'INY', mode: 'imp', bytes: 1 },
    0xC9: { name: 'CMP', mode: 'imm', bytes: 2 },
    0xCA: { name: 'DEX', mode: 'imp', bytes: 1 },
    0xCC: { name: 'CPY', mode: 'abs', bytes: 3 },
    0xCD: { name: 'CMP', mode: 'abs', bytes: 3 },
    0xCE: { name: 'DEC', mode: 'abs', bytes: 3 },
    0xD0: { name: 'BNE', mode: 'rel', bytes: 2 },
    0xD1: { name: 'CMP', mode: 'izy', bytes: 2 },
    0xD5: { name: 'CMP', mode: 'zpx', bytes: 2 },
    0xD6: { name: 'DEC', mode: 'zpx', bytes: 2 },
    0xD8: { name: 'CLD', mode: 'imp', bytes: 1 },
    0xD9: { name: 'CMP', mode: 'aby', bytes: 3 },
    0xDD: { name: 'CMP', mode: 'abx', bytes: 3 },
    0xDE: { name: 'DEC', mode: 'abx', bytes: 3 },
    0xE0: { name: 'CPX', mode: 'imm', bytes: 2 },
    0xE1: { name: 'SBC', mode: 'izx', bytes: 2 },
    0xE4: { name: 'CPX', mode: 'zp', bytes: 2 },
    0xE5: { name: 'SBC', mode: 'zp', bytes: 2 },
    0xE6: { name: 'INC', mode: 'zp', bytes: 2 },
    0xE8: { name: 'INX', mode: 'imp', bytes: 1 },
    0xE9: { name: 'SBC', mode: 'imm', bytes: 2 },
    0xEA: { name: 'NOP', mode: 'imp', bytes: 1 },
    0xEC: { name: 'CPX', mode: 'abs', bytes: 3 },
    0xED: { name: 'SBC', mode: 'abs', bytes: 3 },
    0xEE: { name: 'INC', mode: 'abs', bytes: 3 },
    0xF0: { name: 'BEQ', mode: 'rel', bytes: 2 },
    0xF1: { name: 'SBC', mode: 'izy', bytes: 2 },
    0xF5: { name: 'SBC', mode: 'zpx', bytes: 2 },
    0xF6: { name: 'INC', mode: 'zpx', bytes: 2 },
    0xF8: { name: 'SED', mode: 'imp', bytes: 1 },
    0xF9: { name: 'SBC', mode: 'aby', bytes: 3 },
    0xFD: { name: 'SBC', mode: 'abx', bytes: 3 },
    0xFE: { name: 'INC', mode: 'abx', bytes: 3 },
};